export enum FormFieldNameEnum {
  DecisionField = 'DecisionField',
  MinField = 'MinField',
  MaxField = 'MaxField',
}
